export const ADD_COMMITMENT = 'ADD_COMMITMENT';
export const GET_COMMITMENT = 'GET_COMMITMENT';
export const END_COMMITMENT_STREAM = 'END_COMMITMENT_STREAM';
export const GET_COMMITMENT_RECRUITEES = 'GET_COMMITMENT_RECRUITEES';



// WEBPACK FOOTER //
// ./src/constants/commit.js